import { Component, OnInit } from '@angular/core';
import { WellbeingHubCaetgory, WellbeingHubCategory } from 'src/app/shared/models/wellbeing-hub.model';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { LogService } from '../../shared/services/log.services';
import { ResourcesService } from 'src/app/shared/services/resources.service';
import { UserService } from '../../shared/services/user.service';
import { RedirectRoutesConstants } from '../../shared/global/redirectRoutes.contants';
import { Router } from '@angular/router';


@Component({
  selector: 'ben-wellbeing-hub',
  templateUrl: './wellbeing-hub.component.html',
  styleUrls: ['./wellbeing-hub.component.scss']
})

export class WellbeingHubComponent implements OnInit {
  public spectrumID: string = "";
  wellbeingCategories: WellbeingHubCategory[] = [];
  loading: boolean = true;
   
  constructor(private notificataionService: NotificationService,
    private userService: UserService,
    private logService: LogService,
    private resourcesService: ResourcesService,
    private router: Router){ }

  ngOnInit(): void {
    this.userService.GetSpectrumID().subscribe(spectrumID => {
      if (!spectrumID) {
        this.router.navigate([RedirectRoutesConstants.BeforeYouStartUrl])
      }
      this.userService.CreateOrUpdateSpectrumUser();
      this.loadCategories();
    });
  }

  private loadCategories() {
    this.resourcesService.getWellbeingHubCategories().subscribe(result => {
      this.wellbeingCategories = result;
      this.wellbeingCategories.forEach(cat => {
        cat.icon = this.allocatedCategoryIcons(cat.key);
      });
      this.loading = false;

    });
  }
  private allocatedCategoryIcons(categoryType: string): string {
    switch (categoryType) {
      case WellbeingHubCaetgory.fitness:
        return "fitness_center";
      case WellbeingHubCaetgory.webinars:
        return "today";
      case WellbeingHubCaetgory.classes:
        return "live_tv";
      case WellbeingHubCaetgory.wellbeing:
        return "spa";
      case WellbeingHubCaetgory.nutrition:
        return "restaurant_menu";
      case WellbeingHubCaetgory.beCalm:
        return "self_improvement";
      default:
        return "";
    }
  }
}
